export default {
  setting: {
    wholeNumMessage: "Deve tutto il numero",
    profileAuthSetting: "Impostazioni di autenticazione del profilo",
    logInOutSetting: "Impostazioni Login/Logout",
    autoLogout: "Auto-logout",
    unsuccessfulLoginAttempt: "Unsuccessful Login Attemps",
    unsuccessfulLoginLockPeriod: "Accesso senza successo Periodo di blocco",
    passCriteriaSetup: "Impostazione Criteri di password",
    passLength: "Lunghezza della password",
    noUniquePassRequired: "Numero di password uniche richieste",
    maxPassAge: "Età massima della password",
    acceptableRangeOfChars: "Gamma accettabile di caratteri",
    upperCase: "Caso superiore",
    lowerCase: "Caso più basso",
    numbers: "Numeri",
    specialChars: "Personaggi speciali",
    uniqueSymbols: "Simboli unici",
    loadingData: "Caricamento dati...",
    currency: "Valuta",
    codeActivationTime: "Tempo di attivazione del codice",
    changeGlobalSetting: "Cambiare le impostazioni globali",
    globalSetting: "Impostazioni globali",
    generalSetting: "Impostazioni generali",
    hour: "Ore",
    days: "Giorni",
    minutes: "Processo verbale",
    perDay: "Per giorno",
    perHour: "Per ora",
    customised: "Personalizzato",
    areaUnit: "Unità di area",
    weightUnit: "Unità di peso",
    minimumPwdLen: "Lunghezza minima della password consentita",
    otpPlaceholder: "Generare OTP a 6 cifre",
    generateOTP: "Generare OTP",
    smallFarm: "Piccola fattoria",
    inclusive: "Inclusi",
    from: "Da",
    to: "A",
    mediumFarm: "Fattoria media",
    largeFarm: "Grande azienda agricola",
    requiredMessage: "Questo campo è richiesto",
    nonNegativeMessage: "Questo campo non deve essere negativo",
    fieldToGreaterThanFrom:
      "Questo campo dovrebbe essere maggiore del campo 'Da'",
    fieldToGreaterThanFromMedium:
      'Questo campo dovrebbe essere maggiore del campo "To" di Small Farm',
    fieldToGreaterThanMediumTo:
      "Questo campo dovrebbe essere maggiore del campo 'To' di Medium Farm",

    farmSettings: "Impostazioni della fattoria",
    profileSettings: "Impostazioni del profilo",
    enterpriseSettings: "Impostazioni dell'azienda",
    coffeeSettings: "Impostazioni del caffè",
  },
};
